/* global $ */
import { hasIOSupport } from '../helpers/feature-detects';
import { slugify } from '../helpers/urls';

let count = 0;
const headerSelector = 'h2,h3,h4,h5';

const $tocSection = $.$body.find('article .has-table-of-contents #content');

const $headers = $tocSection.find(headerSelector);
$headers.filter(':empty').remove();
$headers.not(':empty,.accordion__headline').each(function() {
  // console.log(this);
  const $header = $(this);

  const isHeaderModule = $header.is('.module-headline');
  const title = $header.text();
  const slug = `${$header.attr('id') || slugify(title)}-${++count}`;

  if (isHeaderModule) {
    $header
      .closest('.module')
      .addClass('toc-section')
      .attr('id', slug);
  } else {
    $header
      .nextUntil(headerSelector)
      .addBack()
      .wrapAll(`<section class="toc-section" id="${slug}"/>`)
      .closest('section');
  }
});

const $tocItems = $('.table-of-contents').find('li');

// makes header into clickable landmarks
$tocSection.on('click', headerSelector, (e) => {
  const $header = $(e.currentTarget);
  const id = $header.closest('.toc-section').attr('id');
  if (id) {
    window.location.hash = id;
  }
});

let $previousSection = null;
const { location, history } = window;

function setTocActive() {
  const $firstActive = $tocSection.find('.toc-active').eq(0);
  let id;

  if ($firstActive.length) {
    id = $firstActive.closest('.toc-section').attr('id');
  } else if ($previousSection) {
    id = $previousSection.closest('.toc-section').attr('id');
  }

  // console.log(id, $firstActive.length, $firstActive.closest('.toc-section'));

  if (id) {
    $tocItems.removeClass('toc-active');
    $tocItems
      .find(`[data-for="${id}"]`)
      .parent()
      .addClass('toc-active')
      .get(0);

    // if (item.scrollIntoView) {
    //   item.scrollIntoView();
    // }

    setTimeout(
      () =>
        history.replaceState(
          {},
          '',
          location.hash
            ? location.href.replace(location.hash, `#${id}`)
            : `${location.href}#${id}`,
        ),
      200,
    );

    // console.log(
    //   $navItem.closest('.table-of-contents').scrollTop(),
    //   $navItem.closest('.table-of-contents').innerHeight(),
    //   $navItem.position().top,
    // );
  }
}

if (hasIOSupport) {
  window.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // console.log(entry.target, entry.isIntersecting);
          const { target, isIntersecting } = entry;
          const $entry = $(target);
          if (isIntersecting && !$entry.hasClass('toc-active')) {
            $entry.addClass('toc-active');
            $previousSection = $entry;
          } else {
            $entry.removeClass('toc-active');
          }
          setTocActive();
        });
      },
      {
        rootMargin: '56px 0px 20px 0px',
        threshold: [1],
      },
    );

    $headers.each((i, section) => {
      observer.observe(section);
    });
  });
}

// if (window.CSS && window.CSS.supports) {
//   const { supports } = window.CSS;
//   if (!supports('scroll-margin-top:1px')) {
//     $.$body.on('click', '[id]', (e) => {
//       const $el = $(e.currentTarget);
//       const id = $el.attr('id');
//       const $target = $(id);
//       if ($target.length) {
//         $('html, body').animate({
//             scrollTop: ($target.offset().top - 160),
//         }, 100);
//       }
//     });
//   }
// }
